import React, { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Copy, Mail } from "lucide-react";

const EMAIL = "jane@kohc.co.uk";

export function EmailJaneLink({ children = "Email Jane", subject = "Paying in instalments", testId = "email-jane-link", className = "underline text-brand hover:text-coral" }) {
  const [open, setOpen] = useState(false);
  const mailto = `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(EMAIL); toast.success("Email address copied"); }
    catch { toast.error("Could not copy — the address is " + EMAIL); }
  };
  return (
    <>
      <button type="button" data-testid={testId} onClick={() => setOpen(true)} className={className}>{children}</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="email-jane-dialog" className="max-w-md">
          <DialogHeader>
            <DialogTitle className="text-brand font-heading text-2xl">Email Jane</DialogTitle>
            <DialogDescription>Subject: {subject}</DialogDescription>
          </DialogHeader>
          <div className="flex items-center gap-2 rounded-xl border border-cream-deep bg-cream px-4 py-3">
            <Mail className="h-4 w-4 text-coral shrink-0" />
            <span data-testid="email-jane-address" className="font-semibold text-brand flex-1 select-all">{EMAIL}</span>
            <Button type="button" size="sm" variant="outline" data-testid="email-jane-copy" onClick={copy} className="rounded-full h-8"><Copy className="h-3.5 w-3.5 mr-1" />Copy</Button>
          </div>
          <Button asChild data-testid="email-jane-open" className="w-full rounded-full bg-coral hover:bg-coral-hover text-white h-11">
            <a href={mailto}>Open in my email app</a>
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
